import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button, FormControl } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { useNavigate, useLocation, useParams, data, Link } from "react-router-dom";
import API from "../../services/axiosInstance";
import Permission from "../security/permission";
import { AUTH_CODE } from "../security/authCodes";
import { FormLoader, useFormLoader } from '../common_modules/loader';
// import useSubmitPrevent from "../utils/SubmitPrevent";
import usePreventMultiClick from "../utils/SubmitPrevent";

const InvoiceForm = ({
    mode = 'add',
    defaultValues = {},
    // publisherId = null,
    // publisherGuid = null,
}) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const invoiceId = state?.invoiceId;
    const url = useParams();
    const accId = url?.id;
    const accGuid = url?.guid;
    const [currency, setCurrency] = useState([]);
    const [publisherName, setPublisherName] = useState("");
    const [statusOptions, setStatusOptions] = useState({
        approve: [],
        payment: []
    })

    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook

    const { handleSubmit, register, reset, watch, setError, formState: { errors } } = useForm();
    const approveStatus = watch("approve_status");
    const paymentStatus = watch("payment_status");
    //prevent multiple clicks
    // const submittingRef  = useSubmitPrevent();
    const { btnClicked, setBtnClicked } = usePreventMultiClick();
    // final status conditions 

    const calculateFinalStatus = (originalFinalStatus, approveStatus, paymentStatus) => {

        // If original finalStatus is 0 → always send 0
        if (originalFinalStatus === 1) return 1;

        // If original finalStatus is 1 → always send 1
        if (originalFinalStatus === 0) return 0;

        if ([2, 3, 4, 5, 6].includes(originalFinalStatus)) {
            if (approveStatus === "Pending" && paymentStatus === "Pending") {
                return 2;
            } else if (approveStatus === "Approve" && paymentStatus === "Pending") {
                return 5;
            } else if (approveStatus === "Disapprove" && paymentStatus === "Pending") {
                return 3;
            } else if (approveStatus === "Approve" && paymentStatus === "Paid") {
                return 6;
            }
        }

        return originalFinalStatus;
    }

    const onSubmit = async (data) => {
        // if(submittingRef.current) return;
        // submittingRef.current = true;
        if(btnClicked) return;
        setBtnClicked(true);
        startLoading();
        const approveStatus = data.approve_status;
        const paymentStatus = data.payment_status;
        if (approveStatus === "Disapprove" && paymentStatus === "Paid") {
            setError("approve_status", {
                type: "manual",
                message: "Disapproved invoice cannot be Paid."
            });
            stopLoading();
            return;
        } else if (approveStatus === "Pending" && paymentStatus === "Paid") {
            setError("approve_status", {
                type: "manual",
                message: "Pending invoice cannot be Paid."
            });
            stopLoading();
            return;
        }
        const originalFinalStatus = defaultValues?.finalStatus;
        // Get calculated final status
        const finalStatus = mode === "edit" ? calculateFinalStatus(originalFinalStatus, approveStatus, paymentStatus) : 0;

        // Check for uploaded file
        const uploadedFile = data.upload_payment_advice?.[0];
        // let filePathToSend = defaultValues?.filePath || "";

        // UPLOAD FILE ONLY IN EDIT MODE & APPROVE + PAID
        if (
            mode === "edit" &&
            approveStatus === "Approve" &&
            paymentStatus === "Paid" &&
            uploadedFile
        ) {
            const formData = new FormData();
            formData.append("file", uploadedFile);

            const uploadRes = await API.post(
                `/publisher/invoice/paymentAdvice/${invoiceId}/${accGuid}`,
                formData,
                // { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (uploadRes?.data?.status === "Success") {
                alert(uploadRes?.data?.message)
            } else {
                alert("File upload failed");
                return;
            }
        }

        const payload = {
            id: mode === "add" ? 0 : invoiceId,
            accountId: Number(accId),
            accountGuid: accGuid,
            invoiceSeries: mode === "add" ? 0 : defaultValues.invoiceSeries,
            invoiceMonth: data.month,
            invoiceYear: data.year,
            currency: data.currency,
            paymentAmount: data.payment,
            //  paymentDate:formatDate(data.payment_date),
            paymentDate: data.payment_date,
            description: (data.description).trim(),
            finalStatus: finalStatus,
            invoiceFile: "",
            filePath: mode === "edit" ? data.filePath : '',
            //  status:5,
            //  reminderCount:0,
        }
        try {
            const apiCall = mode === "add"
                ? API.post("/publisher/invoice/finance/save", payload)
                : API.put('/publisher/invoice/update', payload);
            if (approveStatus === "Approve" && paymentStatus === "Paid" && uploadedFile) {
                const formData = new FormData();
                formData.append("file", uploadedFile);
                const uploadeFileRes = await API.post(`/publisher/invoice/paymentAdvice/${invoiceId}/${accGuid}`,
                    formData,
                );
                if (uploadeFileRes?.data?.status !== "Success") {
                    alert(uploadeFileRes?.data?.message || "File upload failed");
                    if (uploadeFileRes?.data?.status === "Success") {
                        navigate(`/invoice-list/${accId}/${accGuid}`);
                    }
                    return;
                }
            }
            const response = await apiCall;
            if (response?.data?.status === "Success") {
                alert(response?.data?.message || "Success");
                reset();
                navigate(`/invoice-list/${accId}/${accGuid}`)
            } else {
                alert(response?.data?.message || "Failed");
            }
        } catch {
            console.error("API Error:", errors);
            alert(errors?.response?.data?.message || "Something went wrong!");
        } finally {
            // submittingRef.current = false;
            setBtnClicked(false);
            stopLoading();
        }
    }

    // currency api
    const currencyApi = async () => {
        startLoading();
        try {
            const currencyRes = await API.get(`/publisher/currency/list/${accId}`)
            setCurrency(currencyRes?.data?.data);
            setPublisherName(currencyRes?.data?.name);
        } catch (error) { console.error(error); } finally {
            stopLoading();
        }

    }

    const finalStatus = (fs) => {
        if (mode === "edit" && defaultValues?.finalStatus !== undefined) {
            // const fs = defaultValues.finalStatus;

            let approve = [];
            let payment = [];

            // Example rules — adjust as per your backend logic
            if ([0, 1].includes(fs)) {
                approve = ["Pending"];
                payment = ["Pending"];
            }
            // else if (fs === 1) {
            //     approve = ["Pending"];
            //     payment = ["Pending"];
            // }
            else if ([2, 3, 4, 5, 6].includes(fs)) {
                approve = ["Pending", "Approve", "Disapprove"];
                payment = ["Pending", "Paid"];
            }
            // else if (fs === 3) {
            //     approve = ["Pending"];
            //     payment = ["Pending"];
            // }
            // else if ([2, 4, 5, 6].includes(fs)) {
            //     approve = ["Approve"];
            //     payment = ["Paid"];
            // }
            console.log("Final Status:", fs);
            console.log("Status Options:", approve, payment);
            setStatusOptions({ approve, payment });
        }

    }
    // Downlaod payment advice
    const downloadPaymentAdvice = async () => {
        if(btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const response = await API.post('/publisher/invoice/paymentAdvice/download',
                {
                    id: defaultValues?.id,
                    accountGuid: defaultValues?.accountGuid,
                    filePath: defaultValues?.filePath,
                },
                { responseType: "blob" }
            );

            // Extract filename from filePath
            const fileName = defaultValues?.filePath?.split("/").pop();
            // Create a download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            console.log(response.data);

            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            a.remove();
            window.URL.revokeObjectURL(url);
            alert("Payment Advice Downloaded Successfully!!");
        } catch (error) {
            console.error("Download Failed:", error);
            alert("Unable to download file!");
        } finally {
            setBtnClicked(false);
            stopLoading();
        }

    }

    useEffect(() => {
        if (mode === "edit" && defaultValues && currency.length > 0) {
            reset({
                ...defaultValues,
                currency: String(defaultValues.currency),
                payment_date: defaultValues.payment_date ? defaultValues.payment_date.split(" ")[0] : ""
                // approve_status: defaultValues.approve_status,
                // payment_status: defaultValues.payment_status,
            });
            finalStatus(defaultValues.finalStatus);
        }
    }, [mode, defaultValues, currency]);

    useEffect(() => {
        currencyApi();
    }, []);

    // useEffect(()=>{
    //     if (mode === "edit" && defaultValues) {
    //     reset(defaultValues);
    //     finalStatus(defaultValues.finalStatus); // pass value directly
    // }
    // }, [mode, defaultValues]);

    const currentYear = new Date().getFullYear();

    // const formatDate = (value) =>{
    //     if(!value) return null;

    //     return value.replace("T", " ") + ":00";
    // }
    // validate month & year
    const validateInvoiceMonth = (value) => {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();

        const selectedMonth = Number(value);
        const selectedYear = Number(watch("year"));

        // Prevent current & future months in current year
        if (
            selectedYear === currentYear &&
            selectedMonth >= currentMonth
        ) {
            return "Current and future months are not allowed";
        }

        // Prevent future year
        if (selectedYear > currentYear) {
            return "Future year is not allowed";
        }

        return true;
    };

    // validate payment date
    const validatePaymentDate = (value) => {

        if (!value) return true;

        const selectedMonth = Number(watch("month"));
        const selectedYear = Number(watch("year"));

        const paymentDate = new Date(value);

        const paymentMonth = paymentDate.getMonth() + 1;
        const paymentYear = paymentDate.getFullYear();

        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
        // Prevent current month payment date
        // if (
        //     paymentMonth === selectedMonth &&
        //     paymentYear === selectedYear
        // ) {
        //     return "Current month payment date is not allowed";
        // }

        // Prevent payment date greater than selected invoice month/year

        if (paymentYear < selectedYear || (paymentYear === selectedYear && paymentMonth < selectedMonth)
        ) {
            return "Payment date should be greater than selected invoice month";
        } else if (paymentYear < currentYear) {
            return "Payments can not be processed for previous months or years.";
        }

        return true;
    };

    const currentY = new Date().getFullYear();
    let yearOptions = [currentY - 1, currentY, currentY + 1];
    const apiYear = Number(defaultValues?.year);
    if (mode === "edit" && apiYear && !yearOptions.includes(apiYear)) {
        yearOptions.unshift(apiYear);
    }   
    
    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Permission code={AUTH_CODE.accounts.publisherListing}>
                    <Link to={'/active-publisher'}><span>Publisher</span></Link>
                </Permission>
                <span>{publisherName}</span>
                {/* <Link to={`/invoice-list/${accId}/${accGuid}`}><span>Invoice List</span></Link> */}
                <span>{mode === "edit" ? "Update" : "Create"}</span>
                {/* {mode === "edit" ? <span>{accId}</span> : ''} */}
                {/* {mode === "edit" ? <span>{publisherName}</span> : ''} */}
            </div>

            <Card className="p-3 instreamRows">
                <span className="text-danger" style={{ fontSize: "12px" }}>All fields marked with * are mandatory</span>
                <h6 className="title mb-5">{mode === "add" ? "Add Invoice" : "Update Invoice"}</h6>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Card className="p-3">
                        <Row>
                            <Col md={3}>
                                <label>Invoice Month <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                <select className="form-select" {...register("month", {
                                    required: "Month is require",
                                    validate: validateInvoiceMonth
                                })}>
                                    <option value="1">January</option>
                                    <option value="2" >February</option>
                                    <option value="3" >March</option>
                                    <option value="4" >April</option>
                                    <option value="5" >May</option>
                                    <option value="6" >June</option>
                                    <option value="7" >July</option>
                                    <option value="8" >August</option>
                                    <option value="9" >September</option>
                                    <option value="10" >October</option>
                                    <option value="11" >November</option>
                                    <option value="12" >December</option>
                                </select>
                                {errors.month && <p className="text-danger">{errors.month.message}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Invoice Year <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                {/* <select className="form-select" defaultValue={currentYear} {...register("year", { required: "Year is require" })}>
                                    { mode === "edit" && 
                                        <option>{data.year}</option>
                                    }
                                    {(() => {
                                        
                                        return [currentYear - 1, currentYear, currentYear + 1].map((year) => (
                                            <option key={year} value={year}>{year}</option>
                                        ));
                                    })()}
                                </select> */}
                                <select
                                    className="form-select"
                                    {...register("year", { required: "Year is require" })}
                                >
                                    {yearOptions.map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </select>
                                {errors.year && <p className="text-danger">{errors.year.message}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Currency <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                <select className="form-select" {...register("currency", { required: "Currency is require" })}>
                                    <option value="">Select Currency</option>
                                    {
                                        currency.map((curr) => (
                                            <option value={curr?.id}>{curr?.currencyCode}</option>
                                        ))
                                    }
                                </select>
                                {errors.currency && <p className="text-danger">{errors.currency.message}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Payment Amount <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="number" placeholder="Enter here..." {...register("payment", {
                                    required: "Paymount amount is required",
                                    validate: (value) =>
                                        parseFloat(value) > 0 || "Payment amount must be greater than 0"
                                })} />
                                {errors.payment && <p className="text-danger">{errors.payment.message}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Payment Date <span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="date" placeholder="Enter here..." {...register("payment_date", { required: "Paymount date is required", validate: validatePaymentDate })} />
                                {errors.payment_date && <p className="text-danger">{errors.payment_date.message}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label>Description</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control as="textarea" rows={6} placeholder="Enter here..." {...register("description")} />
                            </Col>
                        </Row>
                        {mode === "edit" ?
                            <>
                                <Row>
                                    <Col md={3}>
                                        <label>Approve Status</label>
                                    </Col>
                                    <Col md={5}>
                                        {/* <Form.Select {...register("approve_status")} defaultValue={defaultValues.approveStatus}> */}
                                        <Form.Select {...register("approve_status")}>
                                            {
                                                statusOptions.approve.map((option, i) => (
                                                    <option key={i} value={option}>{option}</option>
                                                ))
                                            }
                                            {/* <option value="Pending">Pending</option>
                                            <option value="Approve">Approve</option>
                                            <option value="DisApprove">DisApprove</option> */}
                                        </Form.Select>
                                        {errors.approve_status && <p className="text-danger">{errors.approve_status.message}</p>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <label>Payment Status</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Select {...register("payment_status")}>
                                            {
                                                statusOptions?.payment.map((option, i) => (
                                                    <option key={i} value={option}>{option}</option>
                                                ))
                                            }
                                            {/* <option value="pending">Pending</option>
                                            <option value="paid">Paid</option> */}
                                        </Form.Select>
                                    </Col>
                                </Row>

                                {approveStatus === "Approve" && paymentStatus === "Paid" && (
                                    <Row>
                                        <Col md={3}>
                                            <label>Upload Payment Advice</label>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Control type="file" {...register("upload_payment_advice")} />
                                        </Col>
                                    </Row>)}

                                {mode === "edit" && defaultValues?.filePath && defaultValues?.finalStatus && approveStatus === "Approve" && paymentStatus === "Paid" && (
                                    <Row>
                                        <Col md={3}>
                                            {/* <label>Existing Payment Advice</label> */}
                                        </Col>
                                        <Permission code={AUTH_CODE.financeInvoice.downloadPaymentAdvice}>
                                            <Col md={5}>
                                                <Button type="button" variant="success" className="" disabled={btnClicked} onClick={() => downloadPaymentAdvice()} style={{ fontSize: "14px" }}>Download Payment Advice</Button>
                                            </Col>
                                        </Permission>
                                    </Row>
                                )}
                            </> : ''
                        }
                    </Card>
                    <Button disabled = {btnClicked} type="submit" variant="primary" className="mt-3 submitBtn">{mode === "add" ? "Create" : "Update"}</Button>
                    <Button type="button" variant="secondary" className="mx-5 mt-3 cancelBtn" onClick={() => navigate(`/invoice-list/${accId}/${accGuid}`)}>Cancel</Button>
                </form>
            </Card>
        </FormLoader>
    )
}

export default InvoiceForm;